export enum PricePeriodEnum {
  monthly = 'monthly',
  bimonthly = 'bimonthly',
  quarterly = 'quarterly',
  semiannual = 'semiannual',
  annual = 'annual'
}
